import ReactDOM from 'react-dom';
import React, { cloneElement, useState, useRef } from 'react';
import {
  useFloating,
  useInteractions,
  useDismiss,
  useHover,
} from '@floating-ui/react-dom-interactions';
import { shift, offset, arrow } from '@floating-ui/react-dom';
import styles from './tooltipDiscount.module.sass';

export const TooltipDiscount = ({ trigger, content, placement, view }) => {
  const [open, setOpen] = useState(false);
  const arrowRef = useRef(null);
  const isWhite = view === 'white';

  const { x, y, reference, floating, strategy, context, middlewareData } =
    useFloating({
      open,
      onOpenChange: setOpen,
      placement: placement ?? 'bottom',
      middleware: [
        offset(8),
        shift({ padding: 16 }),
        arrow({
          element: arrowRef,
        }),
      ],
    });

  const hover = useHover(context, {
    delay: { open: 75, close: 150 },
    mouseOnly: true,
    restMs: 150,
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useDismiss(context),
    hover,
  ]);

  const staticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
  };

  const handleShowDropDown = () => {
    setOpen(true);
  };

  const handleCloseDropDown = () => {
    setOpen(false);
  };

  return (
    <div>
      <div className={styles.toolWrapper}>
        {cloneElement(trigger, {
          ...getReferenceProps({ ref: reference }),
          onClick: handleShowDropDown,
        })}
        {open &&
          ReactDOM.createPortal(
            <button
              className={styles.toolBackdrop}
              onClick={handleCloseDropDown}
            >
              <div
                className={isWhite ? styles.toolInsideWhite : styles.toolInside}
                {...getFloatingProps({
                  ref: floating,
                  style: {
                    position: strategy,
                    left: x ?? 0,
                    top: y ?? 0,
                  },
                })}
              >
                {content}
                <div
                  className={
                    isWhite
                      ? styles.arrowWhite
                      : placement === 'right'
                      ? styles.arrowRight
                      : styles.arrow
                  }
                  ref={arrowRef}
                  style={{
                    left:
                      middlewareData.arrow?.x != null
                        ? `${middlewareData.arrow.x}px`
                        : '',
                    top:
                      middlewareData.arrow?.y != null
                        ? `${middlewareData.arrow.y}px`
                        : '',
                    [staticSide]: '-4px',
                  }}
                />
              </div>
            </button>,
            document.body,
          )}
      </div>
    </div>
  );
};
